import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Light from './headers/light';
import LightAdmin from './headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from 'sweetalert2';
import tw from "twin.macro";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import ScrollToTop from './ScrollToTop';
import { useTranslation } from 'react-i18next';
import Footerr from './footers/Footer';
import './ProductDetails.css';
import { motion, AnimatePresence } from 'framer-motion';

const ProductDetails = () => {
  const { t } = useTranslation();
  // Route is defined as "/product-details/:idAndSlug". Support either plain id or id-with-slug.
  const { idAndSlug } = useParams();
  const id = (idAndSlug || "").toString().split("-")[0];
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();
  const [role, setRole] = useState('');
  const { i18n } = useTranslation();

  // Expand/collapse states for short description and full description
  const [expandShortDesc, setExpandShortDesc] = useState(false);
  const [expandDesc, setExpandDesc] = useState(false);

  // Image zoom state
  const imgRef = useRef(null);
  const [isZoomed, setIsZoomed] = useState(false);
  const [origin, setOrigin] = useState('center center');

  // Upsell states
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [upsellExpanded, setUpsellExpanded] = useState(false);
  const [upsellChoice, setUpsellChoice] = useState('');
  const [selectedDifferentShampoings, setSelectedDifferentShampoings] = useState([]);

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);
  // no-op: previously toggled an unused isActive state

    const fetchProductDetails = async () => {
      if (!id) return; // Avoid calling API with undefined id
      try {
        const response = await fetch(`https://plateformewmg.cloud/api/products/${id}?lang=${i18n.language}`);
        if (!response.ok) throw new Error("Product not found");
        const data = await response.json();
        setProduct(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchProductDetails();
  }, [id, i18n.language]);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      if (!id) return; // Avoid calling API with undefined id
      try {
        const response = await fetch(`https://plateformewmg.cloud/api/same-category/${id}?lang=${i18n.language}`);
        if (!response.ok) throw new Error("Related products not found");
        const data = await response.json();
        setRelatedProducts(data.products);
      } catch (error) {
        console.error(error);
      }
    };
    fetchRelatedProducts();
  }, [id, i18n.language]);
console.log(role);

  const handleAddToCart = () => {
    if (!product || product.StockQuantity <= 0) {
      Swal.fire({
        title: t('Stock_epuise'),
        text: `${product?.Name} ${t('Produit_rupture')}`,
        icon: 'error',
        confirmButtonText: t('ok')
      });
      return;
    }

    if (quantity > product.StockQuantity) {
      Swal.fire({
        title: t('Quantite_insuffisante'),
        text: `${t('Produit_rupture')}.`,
        icon: 'warning',
        confirmButtonText: t('ok')
      });
      return;
    }

    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existingProduct = cart.find(item => item.productID === product.ProductID);
    if (existingProduct) {
      existingProduct.quantity += quantity;
    } else {
      cart.push({
        productID: product.ProductID,
        productName: product.Name,
        productImage: product.image,
        priceGain: product.user_price,
productPrice: ['supplier', 'influenceur', 'client_fidele'].includes(role)
    ? product.distributeur_price
    : product.user_price,
        quantity: quantity
      });
    }

    localStorage.setItem('cart', JSON.stringify(cart));
console.log(cart);
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: `${t('Produit_ajoute')} ${product.Name}`,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  };

  const handleDifferentSelection = (index, productId) => {
    const updated = [...selectedDifferentShampoings];
    updated[index] = productId;
    setSelectedDifferentShampoings(updated);
  };

  const handleUpsellAddToCart = (type) => {
    if (!selectedOffer) return;

    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const itemsToAdd = [];
    const offerQuantity = selectedOffer.id;
    const offerPrice = selectedOffer.price;

    if (type === 'same') {
      itemsToAdd.push({
        productID: product.ProductID,
        productName: product.Name,
        productImage: product.image,
        priceGain: product.user_price,
        productPrice: offerPrice,
        quantity: offerQuantity,
        isOffer: true,
        offerDetails: `${offerQuantity} ${product.Name} — ${offerPrice} DH`
      });
    } else if (type === 'different') {
      const perItemPrice = Math.round(offerPrice / selectedDifferentShampoings.length);
      selectedDifferentShampoings.forEach(pid => {
        const prod = relatedProducts.find(p => p.ProductID === parseInt(pid));
        if (!prod) return;
        itemsToAdd.push({
          productID: prod.ProductID,
          productName: prod.Name,
          productImage: prod.image,
          priceGain: prod.user_price,
          productPrice: perItemPrice,
          quantity: 1,
          isOffer: true,
          offerDetails: `${offerQuantity} Shampoings — ${offerPrice} DH`
        });
      });
    }

    itemsToAdd.forEach(item => cart.push(item));
    localStorage.setItem('cart', JSON.stringify(cart));

    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: `${t('Offre_ajoutee_au_panier')}`,
      showConfirmButton: false,
      timer: 2500,
    });

    navigate('/checkout');
  };

  if (!product) return <div className="loading">{t('loading')}...</div>;
  const CardButton = tw(PrimaryButtonBase)`text-sm flex justify-center items-center mt-4`;
  const CardButtonContainer = tw.div`flex justify-center items-center mt-2 w-auto`;

  return (
    <AnimationRevealPage>
      <ScrollToTop />
      {role === 'supplier' ? <Light /> : role === 'admin' ? <LightAdmin /> : <Light />}

      {/* Top banner with breadcrumb */}
      <div
        style={{
          backgroundColor: '#f5f5f5',
          height: 150,
          display: 'flex',
          alignItems: 'center',
          width: '100vw',
          marginLeft: 'calc(50% - 50vw)',
          marginRight: 'calc(50% - 50vw)'
        }}
        className="mb-4"
      >
        <div className="container text-center">
          <h2 className="mb-1" style={{ color: '#1f2937', fontWeight: 700, fontSize: 24 }}>Shop</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0 justify-content-center">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item"><Link to="/Boutique">Shop</Link></li>
              <li className="breadcrumb-item active" aria-current="page">Product Details</li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6 mb-4">
            <div
              className="position-relative overflow-hidden"
              style={{
                width: '100%',
                height: 400,
                borderRadius: 16,
                boxShadow: '0 10px 24px rgba(0,0,0,0.08)'
              }}
              onMouseEnter={() => setIsZoomed(true)}
              onMouseLeave={() => setIsZoomed(false)}
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = ((e.clientX - rect.left) / rect.width) * 100;
                const y = ((e.clientY - rect.top) / rect.height) * 100;
                setOrigin(`${x}% ${y}%`);
              }}
            >
              <img
                ref={imgRef}
                src={`https://plateformewmg.cloud/storage/${product.image}`}
                alt={product.Name}
                className="w-100 h-100"
                style={{
                  objectFit: 'cover',
                  borderRadius: 16,
                  transition: 'transform 250ms ease, transform-origin 50ms ease',
                  transform: isZoomed ? 'scale(1.6)' : 'scale(1)',
                  transformOrigin: origin,
                  cursor: 'zoom-in'
                }}
              />
            </div>
          </div>

          <div className="col-md-6">
            {/* Category */}
            <p className="text-muted mb-1" style={{ fontSize: '14px' }}>{product.Category}</p>

            {/* Name + Stock badge */}
            <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
              <h2 className="mb-0" style={{ color: '#000000', fontSize: '28px' }}>{product.Name}</h2>
              {product.StockQuantity > 0 && (
                <span className="badge rounded-pill" style={{ backgroundColor: '#e7f5ec', color: '#2f855a', border: '1px solid #2f855a' }}>
                  {i18n.language === 'ar' ? 'متوفر' : 'En stock'}
                </span>
              )}
            </div>

            {/* Stars + optional count */}
            <div className="d-flex align-items-center mb-2">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="bi bi-star-fill me-1" style={{ color: '#f59e0b' }}></i>
              ))}
              {product.reviews_count ? (
                <span className="text-muted ms-2" style={{ fontSize: '14px' }}>
                  {product.reviews_count} {i18n.language === 'ar' ? 'مراجعات' : 'Avis'}
                </span>
              ) : null}
            </div>

            {/* Price row */}
            {(() => {
              const currentPrice = (role === 'supplier' || role === 'influenceur'  || role === 'client_fidele') ? product.distributeur_price : product.user_price;
              const compareAt = product.old_price || product.compare_at_price;
              return (
                <div className="mb-2">
                  <span style={{ color: '#e0a100', fontSize: '22px', fontWeight: 700 }}>
                    {currentPrice} {t('currency')}
                  </span>
                  {compareAt && (
                    <span className="text-muted text-decoration-line-through ms-3" style={{ fontSize: '18px' }}>
                      {compareAt} {t('currency')}
                    </span>
                  )}
                </div>
              );
            })()}

            <div
              className="text-muted"
              style={{
                lineHeight: '1.8rem',
                fontSize: '16px',
                ...(expandShortDesc
                  ? {}
                  : {
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                    }),
              }}
              dangerouslySetInnerHTML={{ __html: product.short_description }}
            />
            <button
              type="button"
              className="btn btn-link p-0 mt-2"
              onClick={() => setExpandShortDesc((v) => !v)}
              style={{ color: '#1e3d56' }}
            >
              {i18n.language === 'ar'
                ? expandShortDesc
                  ? 'عرض أقل'
                  : 'عرض المزيد'
                : expandShortDesc
                ? 'Voir moins'
                : 'Voir plus'}
            </button>

            {product.StockQuantity === 0 && (
              <p className="mb-4" style={{ color: 'red' }}>{t('out_of_stock')}</p>
            )}

            {/* Quantity Input */}
            <div className="mb-4">
              <label htmlFor="quantity" className="form-label">{t('quantity')}:</label>
              <input
                type="number"
                className="form-control"
                id="quantity"
                value={quantity}
                min="1"
                max={product.StockQuantity}
                onChange={(e) => setQuantity(Number(e.target.value))}
                style={{ width: '80px' }}
              />
            </div>

            {/* 🧩 Collapsible Upsell Section */}
            {product.Category === 'Shampoing' && (
              <div className="my-4 p-3 rounded" style={{ backgroundColor: '#f9f9f9' }}>
                <button
                  className="btn w-100 d-flex justify-content-between align-items-center"
                  style={{
                    backgroundColor: '#133b8c',
                    color: 'white',
                    fontSize: '16px',
                    padding: '10px 15px',
                  }}
                  onClick={() => setUpsellExpanded(prev => !prev)}
                >
                  <span>{t('Voir_les_promotions')}</span>
                  <i className={`bi ${upsellExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                </button>

                <AnimatePresence>
                  {upsellExpanded && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4 }}
                      className="overflow-hidden mt-3"
                    >
                      <h3 className="text-center mb-4" style={{ color: '#133b8c' }}>
                        {t('Choisissez_une_de_nos_promotions')}
                      </h3>

                      <div className="d-flex flex-column align-items-center">
                        {[
                          { id: 2, label: t("2_Shampoings"), price: 210 },
                          { id: 3, label: t("3_Shampoings"), price: 300 },
                          { id: 4, label: t("4_Shampoings"), price: 385 },
                        ].map((offer) => (
                          <div key={offer.id} className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="upsellOffer"
                              id={`offer-${offer.id}`}
                              value={offer.id}
                              onChange={() => setSelectedOffer(offer)}
                              checked={selectedOffer?.id === offer.id}
                            />
                            <label className="form-check-label" htmlFor={`offer-${offer.id}`}>
                              {offer.label} — <strong>{offer.price} DH</strong>
                            </label>
                          </div>
                        ))}

                        {selectedOffer && (
                          <div className="mt-3">
                            <h5 style={{ color: '#133b8c' }}>{t('Souhaitez_vous')}</h5>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="upsellType"
                                id="sameShampo"
                                checked={upsellChoice === 'same'}
                                onChange={() => setUpsellChoice('same')}
                              />
                              <label className="form-check-label" htmlFor="sameShampo">
                                {t('Le_meme_shampoing')}
                              </label>
                            </div>

                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="upsellType"
                                id="differentShampo"
                                checked={upsellChoice === 'different'}
                                onChange={() => setUpsellChoice('different')}
                              />
                              <label className="form-check-label" htmlFor="differentShampo">
                                {t('Choisir_parmi_nos_shampoings')}
                              </label>
                            </div>
                          </div>
                        )}

                        {selectedOffer && upsellChoice === 'same' && (
                          <div className="mt-4">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: '#1e3d56',
                                color: 'white',
                                width: '220px',
                                fontSize: '16px',
                              }}
                              onClick={() => handleUpsellAddToCart('same')}
                            >
                              {t('Passer_a_la_caisse')}
                            </button>
                          </div>
                        )}

                        {selectedOffer && upsellChoice === 'different' && (
                          <div className="mt-4">
                            <p>{t('Sélectionnez_vos_shampoings')}</p>
                            {Array.from({ length: selectedOffer?.id || 0 }).map((_, index) => (
                              <select
                                key={index}
                                className="form-select mb-2"
                                onChange={(e) => handleDifferentSelection(index, e.target.value)}
                              >
                                <option value="">{t('Choisir_un_shampoing')}</option>
                                {relatedProducts.map((rp) => (
                                  <option key={rp.ProductID} value={rp.ProductID}>
                                    {rp.Name}
                                  </option>
                                ))}
                              </select>
                            ))}
                            <button
                              className="btn mt-3"
                              style={{
                                backgroundColor: '#1e3d56',
                                color: 'white',
                                width: '220px',
                                fontSize: '16px',
                              }}
                              onClick={() => handleUpsellAddToCart('different')}
                            >
                              {t('Ajouter_au_panier_et_passer_a_la_caisse')}
                            </button>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )}

            {/* Buttons */}
            <div className="d-flex gap-3">
              <button
                className="btn"
                style={{ backgroundColor: '#133b8c', color: 'white', width: '200px', fontSize: '16px', padding: '10px' }}
                onClick={handleAddToCart}
              >
                <i className="bi bi-cart-plus"></i> {t('add_to_cart')}
              </button>

              <button
                className="btn"
                style={{ backgroundColor: 'white', color: '#1e3d56', border: '1px solid #1e3d56', width: '200px', fontSize: '16px', padding: '10px' }}
                onClick={() => navigate('/checkout')}
              >
                <i className="bi bi-credit-card"></i> {t('Passer_a_la_caisse')}
              </button>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="p-4" style={{ marginTop: '-2rem', paddingTop: '1rem', paddingBottom: '1rem' }}>
          <h1 className="mt-5 text-center" style={{ color: "#428964", fontSize: "1.5rem", marginBottom: '20px' }}>Description</h1>
          <div
            className="text-muted"
            style={{
              lineHeight: '1.8rem',
              fontSize: '16px',
              ...(expandDesc
                ? {}
                : {
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                  }),
            }}
            dangerouslySetInnerHTML={{ __html: product.Description }}
          />
          <div className="d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-link p-0 mt-2"
              onClick={() => setExpandDesc((v) => !v)}
              style={{ color: '#1e3d56' }}
            >
              {i18n.language === 'ar'
                ? expandDesc
                  ? 'عرض أقل'
                  : 'عرض المزيد'
                : expandDesc
                ? 'Voir moins'
                : 'Voir plus'}
            </button>
          </div>
        </div>

        {/* Related Products */}
        <h1 className="mt-5 text-center" style={{ color: "#133b8c", fontSize: "1.5rem" }}>{t('Vous_aimerez')}</h1>
        <br /><br />

        <div className="row">
          {relatedProducts.length > 0 ? (
            relatedProducts.slice(0, 4).map((relatedProduct) => (
              <div key={relatedProduct.ProductID} className="col-md-3">
                <div className="card border-0">
                  <Link to={`/product-details/${relatedProduct.ProductID}`}>
                    <img
                      src={`https://plateformewmg.cloud/storage/${relatedProduct.image}`}
                      className="card-img-top"
                      alt={relatedProduct.Name}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </Link>
                  <div className="card-body text-center">
                    <h5 className="card-title text-truncate" style={{ fontSize: "14px", color: "#00000", marginBottom: "0.5rem" }}>
                      {relatedProduct.Name}
                    </h5>
                    <p className="card-text" style={{ fontSize: "16px", fontWeight: "semibold", color: "#133b8c" }}>
                      {role === "supplier"
                        ? `${relatedProduct.distributeur_price} ${t("currency")}`
                        : `${relatedProduct.user_price} ${t("currency")}`}
                    </p>
                    <CardButtonContainer>
                      <Link to={`/product-details/${relatedProduct.ProductID}`}>
                        <CardButton>{t('Acheter')}</CardButton>
                      </Link>
                    </CardButtonContainer>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>{t('Aucun_produit_similaire_trouve')}.</p>
          )}
        </div>
      </div>

      <Footerr />
    </AnimationRevealPage>
  );
};

export default ProductDetails;
